import { render, staticRenderFns } from "./PageName.vue?vue&type=template&id=46d4db00&scoped=true"
import script from "./PageName.vue?vue&type=script&lang=ts"
export * from "./PageName.vue?vue&type=script&lang=ts"
import style0 from "./PageName.vue?vue&type=style&index=0&id=46d4db00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4db00",
  null
  
)

export default component.exports